import React, { useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import UserName from '../UserName/UserName'
import ChatFilterNav from './ChatFilterNav'
import { setFocusedNativeMessageId } from '../../actions/activeUser'
import { styles } from './styles'

const ChatHeader = props => {
  const { classes, user, messageFilter } = props
  const { filterMessageIds } = user

  const [currentIndex, setCurrentIndex] = useState(0)

  // Reset navigation index whenever the active chat or filter changes
  useEffect(() => {
    setCurrentIndex(0)
  }, [user.chatId, messageFilter])

  const showFilterNav = messageFilter !== 'all' && filterMessageIds?.length > 0

  const filterLabel = messageFilter === 'USEFUL' ? 'Useful' : 'Less Useful'

  const handlePrevious = () => {
    const newIndex = currentIndex - 1
    setCurrentIndex(newIndex)
    setFocusedNativeMessageId(filterMessageIds[newIndex])
  }

  const handleNext = () => {
    const newIndex = currentIndex + 1
    setCurrentIndex(newIndex)
    setFocusedNativeMessageId(filterMessageIds[newIndex])
  }

  return (
    <div className={classes.container}>
      <UserName />
      {showFilterNav && (
        <div className={classes.filterWrap}>
          <ChatFilterNav
            currentFilter={filterLabel}
            currentIndex={currentIndex + 1}
            totalCount={filterMessageIds.length}
            onPrevious={handlePrevious}
            onNext={handleNext}
          />
        </div>
      )}
    </div>
  )
}

ChatHeader.propTypes = {
  classes: PropTypes.object,
  user: PropTypes.object,
  messageFilter: PropTypes.string,
}

const mapStateToProps = state => ({
  user: state.activeUser,
  messageFilter: state.searchQuery.messageFilter,
})

export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(ChatHeader)),
)
